var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { PrimaryLink } from "../../../components/elements/Link/styled";
import styled from "styled-components";
export var StyledRecaptcha = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  order: 0;\n  margin: 0 auto 2rem auto;\n  display: ", ";\n"], ["\n  order: 0;\n  margin: 0 auto 2rem auto;\n  display: ", ";\n"])), function (_a) {
    var $hidden = _a.$hidden;
    return ($hidden ? "none" : "block");
});
export var StyledRecaptchaText = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 2rem;\n  order: 2;\n  a{\n    ", "\n  }\n"], ["\n  margin-top: 2rem;\n  order: 2;\n  a{\n    ", "\n  }\n"])), PrimaryLink);
var templateObject_1, templateObject_2;
